export default __webpack_public_path__ + "static/media/release9.0288cf6a.jpeg";